import { INDUSTRIES } from "../navigation";

/**
 * Sorts the industries routes based on a predefined order.
 * @param routes The array of routes to be sorted.
 * @returns The sorted array of routes.
 */
export const sortIndustriesRoutes = (routes: {
  path: string;
  title: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }>;
}[], isMobile: boolean) => {
  if (isMobile) return routes;

  const sortOrder = [
    INDUSTRIES.carShare,
    INDUSTRIES.tourismRecreation,
    INDUSTRIES.publicTransport,
    INDUSTRIES.agriculture,
    INDUSTRIES.carRental,
    INDUSTRIES.truckingDelivery,
    INDUSTRIES.emergencyService,
    INDUSTRIES.constructionPlumbing,
    INDUSTRIES.truckingTransport,
    INDUSTRIES.shippingMaritime,
    INDUSTRIES.governmentMunicipalities,
  ];

  return [...routes].sort((a, b) => {
    // Extract the last segment from the path
    const aIndustry = a.path.split('/').pop() || '';
    const bIndustry = b.path.split('/').pop() || '';

    // Find the index of the industry in the sortOrder array
    const indexA = sortOrder.indexOf(aIndustry);
    const indexB = sortOrder.indexOf(bIndustry);

    // If any of the titles are undefined, handle that case
    if (indexA === -1 || indexB === -1) {
      return 0; // Return 0 if unable to determine the correct order
    }

    // Compare the indices to sort the routes
    return indexA - indexB;
  });
};